// TODO when app is in SPA state and we use router, replace this with a hook
import api from "../../services/api";
import { route } from "../../shim/jsbridge";
import { tryCatch } from "../search/util";

const URL_SPLITTER = "/";

export const getPathParts = (pathname?: string) =>
  (pathname ?? window.location?.pathname)?.split(URL_SPLITTER).filter(Boolean);

export const getHelpDropdownItems = () => [
  {
    label: "Open User Guide",
    href: "https://docs.reversinglabs.com/SpectraAnalyze/",
    title: "Open docs.reversinglabs.com",
    target: "_blank",
    className: "main-nav__item-link"
  },
  {
    label: "API Docs",
    href: route("swagger-ui"),
    title: "Spectra-Analyze-API-Docs",
    target: "_blank",
    className: "main-nav__item-link"
  },
  {
    label: "Contact Support",
    href: "mailto:support@reversinglabs.com",
    className: "main-nav__item-link"
  }
];

export const getUserDropdownItems = (
  isAdmin: boolean,
  isLocalLicenseValidOrOnline: boolean
) => [
  {
    value: "admin",
    to: "/admin/",
    className: "main-nav__item-link",
    label: "Administration",
    visible: isAdmin && isLocalLicenseValidOrOnline,
    linkReloadsDocument: true
  },
  {
    value: "user-profile",
    to: route("user_profile"),
    className: "main-nav__item-link",
    label: "User Profile",
    visible: isLocalLicenseValidOrOnline,
    linkReloadsDocument: false
  },
  {
    value: "switch-to-new-ui",
    to: "/ui/",
    className: "main-nav__item-link",
    label: "Switch to New UI",
    visible: true,
    linkReloadsDocument: true,
    onClick: async () => {
      await tryCatch(api.updatePreferredUI("new"));
    }
  },
  {
    value: "log-out",
    to: route("login"),
    className: "main-nav__item-link",
    label: "Log Out",
    visible: true,
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      api.logout();
    }
  }
];

export const formatHeaderAlertCount = (totalCount: number) => {
  if (totalCount > 9) {
    return "9+";
  } else {
    return totalCount;
  }
};
